module.exports = __webpack_public_path__ + "static/media/Search.da56f946.svg";